import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import CMDeactiveCustomer from "../components/cmDeactiveCustomer.jsx";
import Footer from "../components/footer.jsx";

function CMDeactiveCustomerpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <CMDeactiveCustomer/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default CMDeactiveCustomerpage;
